import { render, staticRenderFns } from "./CiviPaymentSEPA.vue?vue&type=template&id=32643ad2&"
import script from "./CiviPaymentSEPA.vue?vue&type=script&lang=js&"
export * from "./CiviPaymentSEPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports